import { render } from "./MetricStat.vue?vue&type=template&id=47f6cf4a&ts=true"
import script from "./MetricStat.vue?vue&type=script&lang=ts"
export * from "./MetricStat.vue?vue&type=script&lang=ts"

import "./MetricStat.vue?vue&type=style&index=0&id=47f6cf4a&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__